import { invalidateCurrentUserBillingInfo } from '@/hooks/query/useQueryUserBillingInfo';
import { deactivatePromotedFreeTrial } from '@/pages/api/scribeAPIV2';
import { toast } from '@heidi/design-system/toast';

import { logger } from '@/utils/logger/logger';
import { useTranslations } from '@heidi/runtime/i18n';
import { invalidateCurrentUserComposite } from '@heidi/workspace/data';
import { useMutation, type UseMutationResult } from '@tanstack/react-query';
const DEACTIVATE_PROMOTED_FREE_TRIAL_MUTATION_KEY = 'DEACTIVATE_PROMOTED_FREE_TRIAL';
export function useDeactivatePromotedFreeTrialMutation(): UseMutationResult<
  void,
  Error,
  void
> {
  const { t } = useTranslations();
  return useMutation<void, Error, void>({
    mutationKey: [DEACTIVATE_PROMOTED_FREE_TRIAL_MUTATION_KEY],
    mutationFn: async () => {
      await deactivatePromotedFreeTrial();
    },
    onSuccess: () => {
      void invalidateCurrentUserComposite();
      void invalidateCurrentUserBillingInfo();
      toast({
        tone: 'default',
        title: t('sideBySide.downgradedToFreeTitle'),
        description: t('sideBySide.downgradedToFreeDescription'),
      });
    },
    onError: (error: unknown) => {
      logger.error('Error reverting trial:', error);
      toast({
        tone: 'destructive',
        title: t('sideBySide.failedToRevertTrialTitle'),
        description: t('sideBySide.failedToRevertTrialDescription'),
      });
    },
  });
}
